<template>
    <mm-select :options="options" v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
const options = [
	{
		value:'completed',
		label:'Completed',
		class:'status-completed'
	},
	{
		value:'processing',
		label:'Processing',
	},
	{
		value:'bad debt',
		label:'Bad Debt',
		class:'status-baddebt'
	},
]

export default{
	data(){
		return {
			options,
		}
	},
	props:['value']
}
</script>